import _get from 'lodash/get';
import { EMPTY_ARRAY, EMPTY_STRING } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { PAGE_NAMES, ACTION, USER_PROFILE_RESOURCES } from 'constant';
import { VIEW_FIELD_KEYS } from '../constants';
import { ACTION_IDS, ACTION_LABELS } from './constants';

export const makeActionList = (params?: any) => {
	const { keyConfig } = params;
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	switch (_get(keyConfig, 'name', EMPTY_STRING)) {
		case VIEW_FIELD_KEYS.REFUND_STATUS:
			return [
				{
					id: ACTION_IDS.CREATE_TOURNAMENT_REFUND_REQUEST,
					label: ACTION_LABELS[ACTION_IDS.CREATE_TOURNAMENT_REFUND_REQUEST],
					isEnabled: () => {
						return hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: USER_PROFILE_RESOURCES.gameplay,
							configActionName: ACTION.createTournamentRefundRequest
						});
					}
				}
			];
		default:
			return EMPTY_ARRAY;
	}
};

export default {
	makeActionList
};
